export default {
  install: function (Vue, _options) {
    return Vue.mixin({
      data: () => ({
        userConfig: {
          signedIn: window.config.userSignedIn,
          isArtist: window.config.userRole === "artist",
          // Prevent window object changes for sensitive variables
          isAdmin: document.querySelector('meta[name="isAdmin"]').getAttribute("content") === "true",
        },
      }),
    })
  },
}
